export default __webpack_public_path__ + "static/media/my-volunteer-mockup-5.53c2bfc5.png";